// extracted by mini-css-extract-plugin
export var statItem = "_ff-1";
export var statsRow = "_ff-0";